/**
 * Brand configuration — driven entirely by React build-time environment variables.
 *
 * Set these in the GitHub Actions workflow (env: section of the build step) or .env:
 *   REACT_APP_BRAND_ID      — 'gds' | (blank = generic demo)
 *   REACT_APP_BRAND_NAME    — e.g. "GDS Jewelers" or "Jewelry ERP"
 *   REACT_APP_BRAND_TAGLINE — subtitle shown on login & sidebar (optional)
 *
 * Logo is resolved from src/assets/ based on REACT_APP_BRAND_ID.
 * Add a new entry to logoMap when onboarding a new client.
 */

// Statically import all client logos so webpack bundles them correctly
import gdsLogo from '../assets/gds-logo.png';
import nijvonLogo from '../assets/nijvon-logo.svg';

const logoMap = {
  gds: gdsLogo,
  demo: nijvonLogo,
};

const brandId = process.env.REACT_APP_BRAND_ID || '';

const brand = {
  name: process.env.REACT_APP_BRAND_NAME || 'Jewelry ERP',
  tagline: process.env.REACT_APP_BRAND_TAGLINE || '',
  logo: logoMap[brandId] || null, // null = show default gem icon
};

export default brand;
